import script from "./SettingsChangeHistorySection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsChangeHistorySection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsChangeHistorySection.vue?vue&type=style&index=0&id=0ecaa6fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecaa6fa"]])

export default __exports__